import { Record } from 'immutable'

export interface IRaceEthnicity {
  readonly description: string
  readonly population: number
  readonly percentage: number
}

const RaceEthnicityRecord = Record({
  description: '',
  percentage: 0,
  population: 0,
})

export class RaceEthnicity extends RaceEthnicityRecord
  implements IRaceEthnicity {
  public static fromJS(initialState?: Partial<IRaceEthnicity>) {
    if (!initialState) {
      return new RaceEthnicity()
    }

    const { ...rest } = initialState

    return new RaceEthnicity({
      ...rest,
    })
  }

  public readonly description: string
  public readonly population: number
  public readonly percentage: number

  constructor(initialState?: Partial<RaceEthnicity>) {
    initialState ? super(initialState) : super()
  }
}
